import { useParams } from 'react-router-dom';
import {
  createDateObject,
  formatIsoDate,
  UserDataQuery,
  useTranslator,
} from '@front-activerse/common-components';
import { useApolloClient } from '@apollo/client';
import {
  DietPlanConnectorApollo,
  DailyDietPlanConnectorApollo,
  DailyDietPlanCacheConnectorApollo,
  MealDetailsCacheConnectorApollo,
  SetUserFlagConnectorApollo,
  FetchNotificationConnectorRemoteConfig,
  FetchClosedNotificationsConnectorFirestoreDb,
} from '@front-activerse/common-components';
import DayPlanIndexContainer from './DayPlanIndexContainer';

const MealPlanIndex = ({
  mealPlanNavigation,
  markNotificationAsClosed,
  getClosedNotifications,
  fetchRemoteConfigFields,
}) => {
  let { date } = useParams();

  if (date) {
    date = createDateObject(date);
  } else {
    date = createDateObject(formatIsoDate(new Date()));
  }

  const client = useApolloClient();
  const { language } = useTranslator();

  const userData = client.readQuery({
    query: UserDataQuery,
  });

  const userId = userData.me.id;

  const remoteConfigLanguageCode = language.substring(0, 2);

  return (
    // idea: pass first data from nativeApp to dayplan to prevent load data from backend.
    <FetchClosedNotificationsConnectorFirestoreDb
      getClosedNotifications={getClosedNotifications}
      userId={userId}
      collectionName="mealplan_notifications"
    >
      {({ ...fetchClosedNotificationsData }) => (
        <FetchNotificationConnectorRemoteConfig
          fetchRemoteConfigFields={fetchRemoteConfigFields}
          remoteConfigFields={[
            'meal_plan_notification_active',
            'meal_plan_notification_id',
            'meal_plan_notification_img',
            'meal_plan_notification_content',
            'meal_plan_notification_close_btn_text',
            'meal_plan_notification_redirect_btn_text',
            'meal_plan_notification_redirect_url_path',
          ]}
          remoteConfigLanguageCode={remoteConfigLanguageCode}
        >
          {({ ...fetchMealPlanNotificationData }) => (
            <DietPlanConnectorApollo>
              {({ ...dietPlanData }) => (
                <DailyDietPlanConnectorApollo date={date}>
                  {({ ...dailyDietPlanData }) => (
                    <DailyDietPlanCacheConnectorApollo date={date}>
                      {({ prefetchSurroundingDays }) => (
                        <MealDetailsCacheConnectorApollo>
                          {({ prefetchMealDetails }) => (
                            <SetUserFlagConnectorApollo>
                              {({ ...setUserFlagData }) => (
                                <DayPlanIndexContainer
                                  date={date}
                                  {...dietPlanData}
                                  {...dailyDietPlanData}
                                  {...fetchMealPlanNotificationData}
                                  {...fetchClosedNotificationsData}
                                  prefetchSurroundingDays={prefetchSurroundingDays}
                                  prefetchMealDetails={prefetchMealDetails}
                                  loading={dailyDietPlanData.loading}
                                  loading2={dietPlanData.loading}
                                  loadingMealPlanNotification={
                                    fetchMealPlanNotificationData.loading ||
                                    fetchClosedNotificationsData.loading
                                  }
                                  {...setUserFlagData}
                                  mealPlanNavigation={mealPlanNavigation}
                                  markNotificationAsClosed={markNotificationAsClosed}
                                  userId={userId}
                                />
                              )}
                            </SetUserFlagConnectorApollo>
                          )}
                        </MealDetailsCacheConnectorApollo>
                      )}
                    </DailyDietPlanCacheConnectorApollo>
                  )}
                </DailyDietPlanConnectorApollo>
              )}
            </DietPlanConnectorApollo>
          )}
        </FetchNotificationConnectorRemoteConfig>
      )}
    </FetchClosedNotificationsConnectorFirestoreDb>
  );
};

export default MealPlanIndex;
